import { ClearableSearchField } from "components/SearchField/SearchField";
import {
  Button,
  Card,
  CardContent,
  FormControl,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { GridSearchIcon } from "@mui/x-data-grid";
import { BTable } from "components/BTable/BTable";
import { getColorMappings } from "components/ColorComponent/ColorComponent";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import PageTitle from "components/pagetitle/pagetitle";
import { useMaterialUIController } from "context";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { fetchCreditsData } from "utils/api";
import { appConstants } from "utils/appConstants";
import { showResMsg } from "utils/generic";
import { genericMessage } from "utils/genericMessages";

function ViewCreditUsed() {
  const [customerReload, setCustomerReload] = useState(false);
  const [deleteDialogeFlag, setDeleteDialogeFlag] = useState(false);
  const [disableColor, setDisableColor] = useState(false);
  const [rows, setRows] = useState([]);
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;
  const { barColor } = getColorMappings(sidenavColor);
  const [title, setTitle] = useState("");
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const dispatch = useDispatch();
  const [values, setValues] = useState({
    _id: [],
    userType: "Admin",
    sortingType: "",
    sortingField: "",
    userStatus: "All",
    durationDate: "",
    fromDate: "",
    toDate: "",
    page: appConstants.page,
    limit: appConstants.limit,
    filterValues: "",
    searchParameterList: [
      "transactionDateTime",
      "creditsPurchased",
      "transactionDescription",
      "creditsUsed",
      "creditsBalance",
      "transactionDateTimeString",
    ],
    userID: JSON.parse(sessionStorage.getItem("LOGIN_DETAILS"))?._id,
    businessUserID: JSON.parse(sessionStorage.getItem("LOGIN_DETAILS"))
      ?.businessUserID,
  });

  useEffect(() => {
    fetchCredits();
  }, []);
  const handlePageChange = (page) => {
    values.page = page;
    fetchCredits();
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    values.page = page;
    values.limit = newPerPage;
    setPerPage(newPerPage);
  };

  const handleSort = async (type, value) => {
    values.sortingType = value;
    values.sortingField = type;
  };

  const fetchCredits = () => {
    fetchCreditsData(
      values,
      (data) => {
        console.log("asdasd", data);
        setTotalRows(data.Result_Output.totalDocs);
        setRows(data.Result_Output.docs);
      },
      dispatch
    );
  };

  const handleSearchFilter = (event) => {
    setValues({ ...values, filterValues: event.target.value });
  };

  let columns = [
    {
      name: "Credits Balance",
      selector: (row) => row.creditsBalance,
      sortable: true,
      sortField: "creditsBalance",
    },
    {
      name: "Credits Used",
      selector: (row) => row.creditsUsed,
      sortable: true,
      sortField: "creditsUsed",
    },
    {
      name: "Transaction Description",
      selector: (row) => row.transactionDescription,
      sortable: true,
      sortField: "transactionDescription",
    },

    {
      name: "Credits Purchased",
      selector: (row) => row.creditsPurchased,
      sortable: true,
      sortField: "creditsPurchased",
    },
    {
      name: "Transaction Date Time",
      selector: (row) => row.transactionDateTimeString,
      sortable: true,
      sortField: "transactionDateTimeString",
    },
  ];
  return (
    <DashboardLayout>
      <DashboardNavbar screenName="Users" />

      <Card color="primary">
        <MDBox
          mx={2}
          mt={-2}
          mb={1.5}
          py={1}
          px={2}
          variant="gradient"
          bgColor={sidenavColor}
          borderRadius="lg"
          coloredShadow="info"
        >
          <MDTypography variant="h6" color="white">
            View Credit Usage
          </MDTypography>
        </MDBox>
        <Grid container display={"flex"} justifyContent="end" mt={2} gap={2}>
          <Grid lg={2.5} xs={6} style={{ marginRight: "30px" }}>
            <ClearableSearchField
              type="text"
              variant="outlined"
              fullWidth
              className="searchButton"
              placeholder="Search..."
              label="Search Filter"
              value={values.filterValues}
              onChange={handleSearchFilter}
              onKeyUp={(e) => {
                if (e.key === "Enter") fetchCredits();
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment>
                    <Button
                      style={{
                        borderRadius: "0px 0.5rem  0.5rem 0px",
                        boxShadow: "none",
                        background: barColor,
                      }}
                      variant="contained"
                      onClick={fetchCredits}
                    >
                      <GridSearchIcon color="white" />
                    </Button>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
        </Grid>
        <CardContent>
          <BTable
            title={title}
            columns={columns}
            data={rows}
            selectableRows={false}
            sortingType={handleSort}
            sortServer
            pagination
            paginationServer
            paginationTotalRows={totalRows}
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
            fixedHeaderScrollHeight="410px"
            fixedHeader={true}
          />
        </CardContent>
      </Card>
    </DashboardLayout>
  );
}

export default ViewCreditUsed;
